<template>
  <div class="identification-submission">
    <div class="sel-content">
      <div class="ident-type" :class="{ active: submissionIndex === 0 }" @click="onSel(0)" v-if="showIdentType(0)">
        <div class="icon-content">
          <div class="icon-phone icon-bg img"></div>
        </div>
        <div class="text-content">
          <div class="type-name">
            {{ $t('crm_identification_submission.sjhrz') }}
          </div>
          <div class="desc">
            {{ $t('crm_identification_submission.frxxsjhyz') }}
          </div>
        </div>
      </div>
      <div class="ident-type" :class="{ active: submissionIndex === 1 }" @click="onSel(1)" v-if="showIdentType(1)">
        <div class="icon-content">
          <div class="icon-cert icon-bg img"></div>
        </div>
        <div class="text-content">
          <div class="type-name">
            {{ $t('crm_identification_submission.shou_quan_zheng_shu') }}
          </div>
          <div class="desc">
            {{ $t('crm_identification_submission.jing_ban_ren_xin_xi') }}
          </div>
        </div>
      </div>
      <div class="ident-type" :class="{ active: submissionIndex === 2 }" @click="onSel(2)" v-if="showIdentType(2)">
        <div class="icon-content">
          <div class="icon-account icon-bg img"></div>
        </div>
        <div class="text-content">
          <div class="type-name">
            {{ $t('crm_identification_submission.qydgzz') }}
          </div>
          <div class="desc">
            {{ $t('crm_identification_submission.qydgzhyz') }}
          </div>
        </div>
      </div>
    </div>
    <div class="identification-submission-msg">
      <div class="company-msg">
        <div class="msg-item base">
          <div class="header">
            <div class="name">
              {{ $t('crm_identification_submission.qi_ye_ji_ben_xin_xi') }}
            </div>
          </div>
          <div class="content">
            <div class="row">
              <div class="key">{{ $t('crm_identification_submission.gong_si_ming_cheng') }}：</div>
              <div class="val">{{ companyData.partnerName }}</div>
            </div>
            <div class="row">
              <div class="key">{{ $t('crm_identification_submission.fa_ren_xing_ming') }}：</div>
              <div class="val">{{ companyData.legalPerson }}</div>
            </div>
            <div class="row">
              <div class="key">{{ $t('crm_identification_submission.frsfz') }}：</div>
              <div class="val">{{ companyData.legalPersonIdentity }}</div>
            </div>
            <div class="row">
              <div class="key">{{ $t('crm_identification_submission.gong_si_di_zhi') }}：</div>
              <div class="val">{{ companyAddress }}</div>
            </div>
          </div>
        </div>
        <div class="msg-item account">
          <div class="header">
            <div class="name">
              {{ $t('crm_identification_submission.qydgzhxx') }}
            </div>
          </div>
          <div class="content">
            <div class="row">
              <div class="key">{{ $t('crm_identification_submission.dui_gong_zhang_hao') }}：</div>
              <div class="val">{{ companyData.depositNumber }}</div>
            </div>
            <!-- <div class="row">
              <div class="key">开户行：</div>
              <div class="val">{{bankView}}</div>
            </div> -->
            <div class="row">
              <div class="key">{{ $t('crm_identification_submission.kai_hu_yin_hang') }}：</div>
              <div class="val">{{ companyData.depositBank }}</div>
            </div>
          </div>
        </div>
      </div>

      <el-form ref="form" :model="form" :rules="rules" class="form">
        <div class="msg-legal" v-if="submissionIndex === 0">
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item prop="legalPersonMobile" :label="$t('crm_identification_submission.fa_ren_shou_ji_hao')">
                <el-input v-model="form.legalPersonMobile" :placeholder="$t('Common.com_please_input')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-row :gutter="8">
                <el-col :span="14">
                  <el-form-item prop="code1" :label="$t('crm_identification_submission.shou_ji_yan_zheng_ma')">
                    <el-input v-model="form.code1" :placeholder="$t('Common.com_please_input')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="." class="empty-label">
                    <el-button type="primary" @click="sendCode(0)">{{ $t('crm_identification_submission.huo_qu_yan_zheng_ma') }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div class="msg-ident" v-if="submissionIndex === 1">
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item prop="legalAgent" :label="$t('crm_identification_submission.jbrxm')">
                <el-input v-model="form.legalAgent" :placeholder="$t('Common.com_please_input')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="legalAgentIdentity" :label="$t('crm_identification_submission.jbrsfzh')">
                <el-input v-model="form.legalAgentIdentity" :placeholder="$t('Common.com_please_input')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="legalAgentMobile" :label="$t('crm_identification_submission.jbrsjh')">
                <el-input v-model="form.legalAgentMobile" :placeholder="$t('Common.com_please_input')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-row :gutter="8">
                <el-col :span="14">
                  <el-form-item prop="code2" :label="$t('crm_identification_submission.shou_ji_yan_zheng_ma')">
                    <el-input v-model="form.code2" :placeholder="$t('Common.com_please_input')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="." class="empty-label">
                    <el-button type="primary" @click="sendCode(1)">{{ $t('crm_identification_submission.huo_qu_yan_zheng_ma') }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <div class="common-tips">
            <i class="icon icon-tishi"></i>
            <div class="text">
              {{ $t('crm_identification_submission.xzsqshxqyxdygzzscsqs') }}
            </div>
          </div>
          <div class="download-cert-tpl">
            <i class="icon icon-daoru"></i>
            <span class="text">{{ $t('crm_identification_submission.sqzsmb') }}</span>
          </div>
          <t-upload
            type="file"
            :bizId="partnerId"
            bizType="crm.partner.authCert"
            ref="crmPartnerAuthCert"
            v-model="partnerInstructionList"
            buttonIcon="icon-daochu"
            :buttonText="$t('crm_identification_submission.shou_quan_zheng_shu')"
            class="cert"
            :tip="$t('crm_identification_submission.zcPDFWordgsdgwj2Myn')"
            :autoUpload="false"
          ></t-upload>
        </div>
        <div class="msg-transfer" v-if="submissionIndex === 2">
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item prop="legalAgent" :label="$t('crm_identification_submission.jbrxm')">
                <el-input v-model="form.legalAgent" :placeholder="$t('Common.com_please_input')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="legalAgentIdentity" :label="$t('crm_identification_submission.jbrsfzh')">
                <el-input v-model="form.legalAgentIdentity" :placeholder="$t('Common.com_please_input')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="legalAgentMobile" :label="$t('crm_identification_submission.jbrsjh')">
                <el-input v-model="form.legalAgentMobile" :placeholder="$t('Common.com_please_input')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-row :gutter="8">
                <el-col :span="14" v-if="isShowTransactionAmount">
                  <el-form-item prop="transactionAmount" :label="$t('crm_identification_submission.zhskje')">
                    <el-input v-model="form.transactionAmount" type="number" :min="0" :placeholder="$t('Common.com_please_input')"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="." class="empty-label">
                    <el-button type="primary" class="send-req" :disabled="!isShowTransaction" @click="sendCollectionRquest">
                      {{ $t('crm_identification_submission.fsskqq') }}({{ remainTimes.createPayTimes }})
                    </el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item :label="$t('crm_identification_submission.kai_hu_hang')" prop="bankCode">
                <custom-select code="bank_branch" v-model="form.bankCode" @change="onBankChange" :placeholder="$t('Common.com_please_select')"></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('crm_identification_submission.kai_hu_cheng_shi')" prop="bankRegionCode">
                <custom-select type="tree" v-model="form.bankRegionCode" url="NationRegionTree" :props="cascaderProps" :params="{ status: 1 }" :placeholder="$t('Common.com_please_select')"></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="account-tips" v-if="remainTimes.verifyLastTime">
            <div class="icon-content">
              <i class="icon icon-tishi"></i>
            </div>
            <div class="tips-content">
              <div class="title">
                {{ $t('crm_identification_submission.skqqyfs') }}
              </div>
              <div class="text-content">
                <div class="line" v-html="line1"></div>
                <div class="line" v-html="line2"></div>
                <div class="line">{{ line3 }}</div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <div class="footer">
        <el-button @click="pre">{{ $t('crm_identification_submission.sybqrxx') }}</el-button>
        <el-button type="primary" @click="onNext" :disabled="!isShowAccountSubmit">
          {{ $t('crm_identification_submission.ti_jiao_ren_zheng') }}{{ submissionIndex === 2 ? ['(', remainTimes.payAuthVerifyTimes, ')'].join('') : '' }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import tUpload from '@/components/upload';
import apis from '@/utils/apis.js';

export default {
  components: {
    // cert,
    // msg
    tUpload,
  },
  data() {
    return {
      cascaderProps: {
        label: 'name',
        value: 'nationRegionId',
      },
      companyData: {},
      bankList: [],
      form: {
        // 法人手机号
        legalPersonMobile: '',
        // 经办人姓名
        legalAgent: '',
        // 经办人身份证号
        legalAgentIdentity: '',
        // 经办人手机号
        legalAgentMobile: '',
        // 账户收款金额
        transactionAmount: '',
        code1: '',
        code2: '',
        legalPersonIdentity: '',
        legalPerson: '',
        bankRegionCode: '',
        bankCode: '',
        bankName: '',
      },
      // 授权证书
      partnerInstructionList: [],
      partnerId: '',
      vertifyData1: {},
      vertifyData2: {},
      remainTimes: {
        // 发起次数
        createPayTimes: 0,
        // 验证次数
        payAuthVerifyTimes: 0,
        // 最后验证时间
        verifyLastTime: '',
      },
      // 如果type为single，则只显示：手机号认证
      type: '',
    };
  },
  computed: {
    rules() {
      return {
        legalPersonMobile: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 15,
            message: this.$t('Common.com_rules_length_max', [15]),
          },
        ],
        code1: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        code2: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        legalAgent: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 20,
            message: this.$t('Common.com_rules_length_max', [20])
          },
        ],
        legalAgentIdentity: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 18,
            message: this.$t('Common.com_rules_length_max', [18]),
          },
        ],
        legalAgentMobile: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 15,
            message: this.$t('Common.com_rules_length_max', [15]),
          },
        ],
        transactionAmount: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        bankRegionCode: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        bankCode: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
    submissionIndex() {
      return this.injectData.submissionIndex;
    },
    // 是否允许发送收款请求
    isShowTransaction() {
      return this.remainTimes.createPayTimes > 0;
    },
    // 是否允许企业对公转账提交
    isShowAccountSubmit() {
      if (this.submissionIndex === 2) {
        return this.remainTimes.payAuthVerifyTimes > 0;
      }
      return true;
    },
    // 发送收款请求默认值是5，如果没有发送过请求，不显示发送收款请求按钮
    isShowTransactionAmount() {
      return this.remainTimes.createPayTimes < 5;
    },
    line1() {
      return this.$t('crm_identification_submission.qzspanclaspanqsrskje', [this.remainTimes.verifyLastTime]);
    },
    line2() {
      return this.$t('crm_identification_submission.qyrzssdkdjtxskjespan');
    },
    line3() {
      return this.$t('crm_identification_submission.dkyxwhzssqlxsssqqydk');
    },
    companyAddress() {
      const companyData = this.companyData || {};
      const { country, province, city, detailAddress } = companyData;

      if (country && province && city && detailAddress) {
        let ret = detailAddress;
        // 去除detailAddress中的省市区
        ret = ret.replace(country, '');
        ret = ret.replace(province, '');
        ret = ret.replace(city, '');
        return [country, province, city, ret].join('');
      }

      return '';
    },
    // 开户行
    // bankView() {
    //   const bankList = this.bankList;
    //   const bankCode = this.companyData.bankCode;
    //   if (bankList && bankList.length && bankCode) {
    //     const item = bankList.find(obj => obj.bankCode === bankCode);
    //     if (item) {
    //       return item.bankName;
    //     }
    //   }
    //   return '';
    // }
  },
  inject: ['pre', 'next', 'setSubmissionIndex', 'injectData'],

  methods: {
    // 获取开户行银行列表
    getBankList() {
      this.$getJSON(apis.crmBankInfoSelectIce).then((res) => {
        this.bankList = res.data;
      });
    },
    showIdentType(index) {
      if (this.type === 'single') {
        return index === 0;
      }
      return true;
    },
    onBankChange(data) {
      this.form.bankName = data.name;
    },
    sendCode(index) {
      const reqData = {
        account: this.companyData.businessLicense,
        identity: index === 0 ? this.form.legalPersonIdentity : this.form.legalAgentIdentity,
        identityType: 0,
        mobile: index === 0 ? this.form.legalPersonMobile : this.form.legalAgentMobile,
        name: index === 0 ? this.form.legalPerson : this.form.legalAgent,
      };
      this.$postJSON(apis.identity3SendMobile, reqData).then((res) => {
        this.$message({
          type: 'success',
          message: this.$t('crm_identification_submission.fa_song_cheng_gong'),
        });
        const data = res.data;
        if (index === 0) {
          this.vertifyData1 = data;
        }
        if (index === 1) {
          this.vertifyData2 = data;
        }
        // vertifyData.personalIdentity3Key
      });
    },
    onSel(index) {
      this.setSubmissionIndex(index);
    },
    // 获取认证信息
    getInfo() {
      this.$getJSON(`${apis.companyAuthToAuth}/${this.partnerId}`).then((res) => {
        const data = res.data;
        Object.assign(this.form, data);
      });
    },
    // 获取公司基本详情
    getCompanyInfo() {
      this.$getJSON(apis.partnerInfo, { partnerId: this.partnerId }).then((res) => {
        const data = res.data;
        this.companyData = data;
      });
    },
    onNext() {
      if (this.submissionIndex === 0) {
        this.legalSubmit();
      }
      if (this.submissionIndex === 1) {
        this.agentSubmit();
      }
      if (this.submissionIndex === 2) {
        this.paySubmit();
      }
    },
    // 法人认证提交
    async legalSubmit() {
      this.$refs.form.validate(async (val) => {
        if (this.$refs.crmPartnerAuthCert) {
          await this.$refs.crmPartnerAuthCert.submit();
        }
        if (val) {
          const reqData = {
            legalPerson: this.form.legalPerson,
            legalPersonIdentity: this.form.legalPersonIdentity,
            legalPersonMobile: this.form.legalPersonMobile,
            partnerId: this.partnerId,
            moblieVerifyIn: {
              vcode: this.form.code1,
              personalIdentity3Key: this.vertifyData1.personalIdentity3Key,
            },
          };
          this.$postJSON(apis.companyAuthAuthSubmitLegal, reqData).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.next();
          });
        }
      });
    },
    // 授权书认证提交
    async agentSubmit() {
      this.$refs.form.validate(async (val) => {
        if (this.$refs.crmPartnerAuthCert) {
          await this.$refs.crmPartnerAuthCert.submit();
        }

        if (val) {
          const reqData = {
            legalAgent: this.form.legalAgent,
            legalAgentIdentity: this.form.legalAgentIdentity,
            legalAgentMobile: this.form.legalAgentMobile,
            moblieVerifyIn: {
              vcode: this.form.code2,
              personalIdentity3Key: this.vertifyData2.personalIdentity3Key,
            },
            partnerId: this.partnerId,
            partnerInstructionList: this.partnerInstructionList,
          };
          this.$postJSON(apis.companyAuthAuthSubmitAgent, reqData).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.next();
          });
        }
      });
    },
    // 企业打款认证提交
    async paySubmit() {
      this.$refs.form.validate(async (val) => {
        if (this.$refs.crmPartnerAuthCert) {
          await this.$refs.crmPartnerAuthCert.submit();
        }
        if (val) {
          const reqData = {
            partnerId: this.partnerId,
            transactionAmount: this.form.transactionAmount,
          };
          this.$postJSON(apis.companyAuthAuthSubmitPay, reqData).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_handle_success'),
            });
            this.next();
          });
        }
      });
    },
    // 发送收款请求
    sendCollectionRquest() {
      // companyAuthEnterpriseCorporateAccountAudit
      const { bankBranchName, bankCard, bankCode, bankName, bankRegionCode, legalAgent, legalAgentIdentity, legalAgentMobile } = this.form;
      const reqData = {
        bankBranchName,
        bankCard,
        bankCardName: this.companyData.partnerName,
        bankCode,
        bankName,
        bankRegionCode: Array.isArray(bankRegionCode) ? bankRegionCode[bankRegionCode.length - 1] : bankRegionCode,
        legalAgent,
        legalAgentIdentity,
        legalAgentMobile,
        partnerId: this.partnerId,
      };
      this.$postJSON(apis.companyAuthEnterpriseCorporateAccountAudit, reqData).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('crm_identification_submission.fa_song_cheng_gong'),
        });
        // 更新数据
        this.getRemainTimes();
      });
    },
    // 剩余企业打款次数，验证次数
    getRemainTimes() {
      this.$postJSON(`${apis.companyAuthEnterpriseCorporateAccountAuditRemainingTimes}/${this.partnerId}`).then((res) => {
        this.$setFormatData(this.remainTimes, res.data);
      });
    },
  },
  mounted() {
    this.partnerId = this.getJump('partnerId');
    this.type = this.getJump('type');

    this.getInfo();
    this.getCompanyInfo();
    this.getRemainTimes();
    this.getBankList();
  },
};
</script>

<style lang="scss" scoped>
.identification-submission {
  padding-top: 24px;
  .sel-content {
    display: flex;
    justify-content: space-between;

    .ident-type {
      width: 289px;
      height: 70px;
      background: #f8f9fb;
      box-shadow: 0 0 0 1px #e4ebf2 inset;
      position: relative;
      cursor: pointer;
      .icon-bg {
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
      }

      &.active {
        background: rgba(13, 154, 224, 0.1);
        box-shadow: 0 0 0 2px #0d9ae0 inset;
        &::before {
          content: ' ';
          width: 28px;
          height: 22px;
          position: absolute;
          bottom: 0;
          right: 0;
          background-image: url('~@/images/layout/icon_auth_checked.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: 100%;
        }
      }

      .icon-content {
        $r: 34px;
        float: left;
        margin-left: 16px;
        margin-top: 16px;
        width: $r;
        height: $r;

        > .img {
          width: $r;
          height: $r;
        }

        .icon-phone {
          background-image: url('~@/images/layout/icon_auth_phone.png');
        }

        .icon-cert {
          background-image: url('~@/images/layout/icon_auth_cert.png');
        }

        .icon-account {
          background-image: url('~@/images/layout/icon_auth_account.png');
        }
      }

      .text-content {
        float: left;
        margin-left: 16px;
        font-size: 12px;
      }

      .type-name {
        color: #495057;
        margin-top: 16px;
        line-height: 17px;
      }
      .desc {
        font-size: 12px;
        margin-top: 3px;
        color: #6c757d;
        line-height: 18px;
      }
    }
  }

  /deep/ .empty-label {
    .el-form-item__label {
      opacity: 0;
    }
  }

  .company-msg {
    margin-top: 24px;
    border-top: 1px solid #eef2f8;

    .msg-item {
      &.base {
        margin-top: 21px;
      }
      &.account {
        margin-top: 11px;
      }
      > .header {
        height: 44px;
        background: #f6f6f6;
        padding-left: 20px;
        padding-right: 16px;
        line-height: 44px;
        font-size: 12px;
        .name {
          font-weight: bold;
          color: #394668;
          float: left;
        }
        .show-all {
          color: #0d9ae0;
          float: right;
        }
      }
      > .content {
        margin-top: 4px;
        padding: 14px 20px;
        background: #fafafa;
        font-size: 12px;
        line-height: 26px;
        .row {
          overflow: hidden;
          .key {
            text-align: right;
            width: 100px;
            float: left;
            color: #6c757d;
          }
          .val {
            overflow: hidden;
            padding-left: 16px;
            color: #394668;
          }
        }
      }
    }
  }

  // .msg-legal {
  //   margin-top: 24px;
  // }

  .form {
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .common-tips {
    background: rgba(13, 154, 224, 0.15);
    height: 28px;
    line-height: 28px;
    padding-left: 10px;
    font-size: 12px;
    margin-top: 8px;
    .icon {
      color: #0d9ae0;
    }
    .text {
      padding-left: 10px;
      color: #6c757d;
      display: inline;
    }
  }

  .msg-ident {
    .download-cert-tpl {
      width: 100%;
      height: 32px;
      line-height: 32px;
      background: #fafafa;
      border: 1px dashed #d6d6d6;
      margin-top: 24px;
      font-size: 12px;
      text-align: center;
      color: #495057;
      cursor: pointer;
      .text {
        padding-left: 8px;
      }
    }
    /deep/ .cert {
      margin-top: 16px;
      width: 100%;
      .el-upload {
        width: 100%;
        .el-button {
          width: 100%;
        }
      }
      .upload-text {
        padding-left: 8px;
      }
    }
  }

  .msg-transfer {
    /deep/ .send-req {
      border: 1px solid #394668;
      background: #394668;
    }

    .account-tips {
      background: rgba(13, 154, 224, 0.15);
      padding: 13px 16px;
      border-radius: 2px;
      margin-top: 8px;
      display: flex;

      .icon-content {
        width: 32px;
        flex-shrink: 0;
        padding-top: 1px;

        .icon {
          font-size: 15px;
          color: #0d9ae0;
          margin-top: 2px;
        }
      }

      .tips-content {
        flex: 1;
        .title {
          color: #495057;
          line-height: 20px;
          font-size: 14px;
          font-weight: bold;
        }
        .text-content {
          margin-top: 5px;
          color: #6c757d;
          font-size: 12px;
          line-height: 20px;
          width: auto;

          .line {
            width: 100%;
            word-break: break-all;
            white-space: normal;
          }

          .date {
            color: #0d9ae0;
            padding: 0 2px;
          }

          .red {
            color: #ff5c5b;
            padding: 0 2px;
          }
        }
      }
    }
  }
}
</style>
